<template>
  <b-container>
    <b-row class="vh-100 text-center" align-v="center">
      <b-col md="4" offset-md="4"> </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "admin-dashboard",

  mounted() {},

  created() {},

  data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {},
};
</script>
